import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import ViList from "@/components/vi/ViList";
import { useAuth } from "@/context/AuthContext";
import { call, VI_MANAGERS } from "@/lib/vi";

const LABELS = { hors_zone: "Hors zone", immobile: "Immobile", signal: "Perte de signal" };
const fmt = (s) => (s || "").slice(0, 16).replace("T", " ");

export default function ViGpsAlerts() {
  const { role } = useAuth();
  const [key, setKey] = useState(0);
  const treat = async (a) => {
    const note = window.prompt("Action menée / commentaire");
    if (note === null) return;
    if (await call(() => api.post(`/itinerant/gps-alerts/${a.id}/resolve`, { note }), "Alerte traitée")) setKey((k) => k + 1);
  };
  return <ViList title="Alertes GPS" subtitle="Tricycles sortis de leur zone, immobiles trop longtemps ou sans signal" endpoint="/itinerant/gps-alerts" testid="vi-gps-alerts" reloadKey={key}
    columns={[{ key: "created_at", label: "Déclenchée", render: (a) => fmt(a.created_at) },
      { key: "type", label: "Type", render: (a) => <span className={`text-xs font-semibold ${a.type === "hors_zone" ? "text-rose-600" : "text-orange-600"}`}>{LABELS[a.type]}</span> },
      { key: "tricycle_code", label: "Tricycle", render: (a) => <span className="font-mono">{a.tricycle_code}</span> }, { key: "vendeur_name", label: "Conducteur" },
      { key: "circuit", label: "Circuit" }, { key: "detail", label: "Détail", render: (a) => <span className="text-xs">{a.detail}</span> },
      { key: "fin_at", label: "Fin", render: (a) => (a.fin_at ? fmt(a.fin_at) : <span className="text-rose-600 text-xs">en cours</span>) },
      { key: "statut", label: "Statut", render: (a) => <StatusBadge value={a.statut} /> },
      { key: "x", label: "", render: (a) => <span className="flex gap-1">
        <Link to={`/vi/tournees/${a.tournee_id}`}><Button size="sm" variant="ghost">Tournée</Button></Link>
        {a.statut === "Ouverte" && VI_MANAGERS.includes(role) && <Button size="sm" variant="outline" onClick={() => treat(a)} data-testid={`gps-alert-resolve-${a.id}`}>Traiter</Button>}</span> }]} />;
}
